import React, { FunctionComponentElement, useState } from "react";
import { NodeInputProps } from "./index";
import { InputTextarea } from "primereact/inputtextarea";
import { ErrorDefaultValueWidget } from "../error/errorDefaultValueWidget";
import styles from "./Form.module.scss"

export const TextInput = ({
  defaultValue,
  value,
  onChange,
  placeholder,
  disabled,
  regex,
  regex_msg
}: NodeInputProps): FunctionComponentElement<NodeInputProps> => {
  const [incorrectDefaultValue, setIncorrectDefaultValue] = useState<boolean>(false);
  const [isValid, setIsValid] = useState(true);

  const verifyType = (value: any) => {
    return typeof value === "string";
  };

  const [valueWidget, setValueWidget] = useState(() => {
    if (value) return value;
    if (defaultValue) {
      if (verifyType(defaultValue)) return defaultValue;
      else setIncorrectDefaultValue(true);
    }
    return undefined;
  });

  return (
    <div>
      <ErrorDefaultValueWidget displayError={incorrectDefaultValue} />
      <InputTextarea
        value={valueWidget}
        onChange={(e) => {
          setIsValid(regex ? regex.test(e.target.value) : true);
          onChange(e.target.value);
          setValueWidget(e.target.value);
          setIncorrectDefaultValue(false)
        }}
        placeholder={placeholder}
        rows={5}
        cols={30}
        disabled={disabled}
        autoResize
        className={isValid ? "" : 'p-invalid'}
      />
      {!isValid && regex_msg && <div className={styles['regex-message']}>{regex_msg}</div>}
    </div>
  );
};
